import {RouteSetOverview} from 'data/records'
import {resource, findSelector} from 'data/helpers/apiv3'
import {fulfilled} from 'lib/promiseMiddlewareHelpers'

const [api, actions] = resource(RouteSetOverview, [])

const selectors = {
  ...findSelector(RouteSetOverview)
}

const reducers = {
  [fulfilled(actions.read.type)]: (state, action) => {
    const {routeSetOverview, meta} = action.payload
    const assets = meta.assets || {}
    // munge legacy format onto the v3record
    return state.setIn(['id', routeSetOverview.id, 'assets'], assets)
  }
}

const initialState = {}

export {
  api as routeSetOverviewApi,
  actions as routeSetOverviewActions,
  selectors as routeSetOverviewSelectors,
  reducers as routeSetOverviewReducers,
  initialState as routeSetOverviewInitialState
}
